module.exports = __webpack_public_path__ + "static/media/John Cardani-Trollinger Headshot.13572a4d.jpeg";